import axios from 'axios'
axios.defaults.withCredentials = true;
const url = 'http://api.ucpvirtual.com.br/api/v2/med/'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default {
    
    actions:{

      async  EnviarMensagemChat (context, value) {
            console.log(value)
        
            // context.commit('PRELOADER_MUDAR', true)
            // const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
        
            await axios.post( url + 'insertmensagenschat/',
            {
                usuarios_id:value.usuarios_id,
                oferta_disciplina_id:value.id,
                mensagem:value.mensagem

            },
              {
                headers: {
                  // 'Authorization': AuthStr,
                  'Content-Type': 'application/json',
                },
              })
              .then(response => {
                 console.log(response.data)
                 
               
              })
              .catch((error) => {
                console.log(error.response.data.message)
              }).finally( () => {
                    //   context.commit('PRELOADER_MUDAR', false)
              })
        },
        async  BuscarMensagensChat (context, value) {
        
          const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
      
          await axios.get( url + 'AllMensagemChat/'+ value.usuarios_id+'/'+value.oferta_disciplina_id,
            {
              headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
              },
            })
            .then(response => {
               console.log(response.data)
               context.commit('SET_MENSAGENS_CHAT', response.data)
              
            })
            .catch((error) => {
              console.log(error.response.data.message)
            }).finally( () => {
                  //   context.commit('PRELOADER_MUDAR', false)
            })
        },

       

    },
    getters:{

    },
    mutations:{
      SET_MENSAGENS_CHAT (state, value) {
            state.MensagensChat =  value
          },
    
        

    },
    state:{
      MensagensChat: [],
    

    },
}